<template>
    <div v-if="house && filterByRent.length > 0" class="district-house" :class="{ close: isClose }">
        <span class="title">
            {{county}}-{{district}}
            <span class="total">
                {{filterByRent.length}}
            </span>
        </span>
        <span class="toggle-close" @click="toggleClose">
            <img :src="arrowImg" :style="{transform: 'rotate('+arrowRotate+'deg)'}" alt="">
        </span>
        <ul>
            <li v-for="(houseItem, index) in filterByRent" :key="index" :class="{'rented': houseItem.empty == 0, 'active': index == selected}" @mouseenter="showCover" @mouseleave="hideCover" @click="getHouseInfo(index), selected = index, setDistrictHouseUid()">
                <div class="state">
                    <ul>
                        <li v-for="(stateItem, index2) in filterStatus(houseItem.status)" :key="index2" > 
                            <span :class="translateStateColor(stateItem)">
                                <img :src="translateStateImg(stateItem, index == selected)" alt="">
                            </span>
                        </li>
                    </ul>
                </div>
                <span class="address">
                    {{houseItem.address}}
                </span>
                <div class="cover">
                    <span class="active-cover"></span>
                    <span class="active-word">{{coverInfo(houseItem.emptyDay,houseItem.leaveDay)}}</span>
                </div>
            </li>
        </ul>
    </div>
    <div v-else-if="house && filterByRent.length == 0" class="district-house filter-no-house" :class="{ close: isClose }">
        <span class="title">
            房源位置
        </span>
        <span class="toggle-close" >
            <img :src="arrowImg" :style="{transform: 'rotate('+arrowRotate+'deg)'}" alt="">
        </span>
        <div class="no-result">
            沒有任何篩選結果
        </div>
    </div>
    <div v-else-if="noHouse" class="district-house no-house">
        <span class="title">
            房源位置
        </span>
        <div class="wrap">
            <span>0 筆資料，尚未新增任何房源</span>
            <router-link :to="{ name: 'addhouse'}">
                <button class="default-button">
                    <img src="../../../assets/img/icon/plus_white.svg" alt="">
                    刊登廣告
                </button>
            </router-link>
        </div>
        <span class="toggle-close" @click="toggleClose">
            <img :src="arrowImg" :style="{transform: 'rotate('+arrowRotate+'deg)'}" alt="">
        </span>
    </div>
    <!-- <div v-else class="district-house loading">
        <span class="title">
        </span>
        <span class="toggle-close" @click="toggleClose">
            <img :src="arrowImg" :style="{transform: 'rotate('+arrowRotate+'deg)'}" alt="">
        </span>
        <ul>
            <li>
                <div class="state">
                    <ul>
                        <li> 
                            <span></span>
                        </li>
                    </ul>
                </div>
                <span class="address">
                </span>
                <span class="floor">
                </span>
            </li>
            <li>
                <div class="state">
                    <ul>
                        <li> 
                            <span></span>
                        </li>
                    </ul>
                </div>
                <span class="address">
                </span>
                <span class="floor">
                </span>
            </li>
            <li>
                <div class="state">
                    <ul>
                        <li> 
                            <span></span>
                        </li>
                    </ul>
                </div>
                <span class="address">
                </span>
                <span class="floor">
                </span>
            </li>
            <li>
                <div class="state">
                    <ul>
                        <li> 
                            <span></span>
                        </li>
                    </ul>
                </div>
                <span class="address">
                </span>
                <span class="floor">
                </span>
            </li>
            <li>
                <div class="state">
                    <ul>
                        <li> 
                            <span></span>
                        </li>
                    </ul>
                </div>
                <span class="address">
                </span>
                <span class="floor">
                </span>
            </li>
            <li>
                <div class="state">
                    <ul>
                        <li> 
                            <span></span>
                        </li>
                    </ul>
                </div>
                <span class="address">
                </span>
                <span class="floor">
                </span>
            </li>
        </ul>
    </div> -->
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name: 'DistrictHouse',
    data () {
        return {
            isCover: 0,
            isClose: 0,
            selected: undefined,
            arrowImg: require('../../../assets/img/icon/arrow_down_black.svg'),
            arrowRotate: '180'
        }
    },
    props: {
        county: String,
        district: String,
        total: Number,
        house: Array,
        empty: Array,
        noHouse: Boolean
    },
    watch: {
        isClose: function () {
            if(this.isClose){
                this.arrowImg = require('../../../assets/img/icon/arrow_down_gray.svg'),
                this.arrowRotate = '0'
            }else{
                this.arrowImg = require('../../../assets/img/icon/arrow_down_black.svg'),
                this.arrowRotate = '180'
            }
        },
        districtHouseUid: function () {
            if( this.districtHouseUid != this._uid){
                this.selected = undefined
            }
        }
    },
    computed: {
        filterByState: function () {
            return this.house.filter((houseItem) => { 
                for (let i = 0; i < this.filterQuery.status.length; i++) {
                    const state = this.filterQuery.status[i];
                    if(houseItem.status.includes(parseInt(state)) == true){
                        // console.log(houseItem)
                        return houseItem
                    }
                }
            });
        },
        filterByEmpty: function () {
            return this.filterByState.filter((houseItem) => {
                if( this.filterQuery.empty.length > 0 ){
                    //當篩選只有單選空房
                    if( this.filterQuery.empty.length == 1  && this.filterQuery.empty == 1 && houseItem.empty == 1){
                        // console.log('1')
                        if( this.filterQuery.status.includes('0') == true ){
                            return houseItem
                        }
                        // 僅呈現空房狀態
                        else{
                            if(houseItem.status.includes(0) == false){
                                return houseItem
                            }
                        }
                    }
                    else if( this.filterQuery.empty.length == 1 && this.filterQuery.empty == 0 && houseItem.empty == 0){
                        if( this.filterQuery.status.length != 0){
                            for (let i = 0; i < this.filterQuery.status.length; i++) {
                                const state = this.filterQuery.status[i];
                                if(houseItem.status.includes(parseInt(state)) == true || houseItem.empty == 0 && houseItem.status.length == 0){
                                    return houseItem
                                }
                            }
                        }else{
                            let allowStatus = this.$store.getters.DEFAULT_FILTER_STATUS
                            if(houseItem.status.includes(parseInt(allowStaus[0])) == false && houseItem.status.includes(parseInt(allowStaus[1])) == false && houseItem.status.includes(parseInt(allowStaus[2])) == false && houseItem.status.includes(parseInt(allowStaus[3])) == false){
                                return houseItem
                            }
                        }
                    }
                    // 選取空房及已租狀態
                    else if(this.filterQuery.empty.length == 2){
                        if( this.filterQuery.status.length > 0 ){
                            for (let i = 0; i < this.filterQuery.status.length; i++) {
                                const state = this.filterQuery.status[i];
                                if(houseItem.status.includes(parseInt(state)) == true || houseItem.status.length == 0){
                                    return houseItem
                                }
                            }
                        }else{
                            return houseItem
                        }
                    }else{
                        return
                    }
                }
            });
        },
        filterByHouseType: function () {
            return this.filterByState.filter((houseItem) => {
                if( this.filterQuery.houseType ){
                    if(houseItem.houseType  == this.filterQuery.houseType){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByBuildingType: function () {
            return this.filterByHouseType.filter((houseItem) => {
                // console.log('filter-buildingType')
                if( this.filterQuery.buildingType ){
                    if(houseItem.buildingType  == this.filterQuery.buildingType){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByContract: function () {
            return this.filterByBuildingType.filter((houseItem) => {
                let rentDateStart = houseItem.contractBeginTime,
                    rentDateEnd = houseItem.contractEndTime,
                    filterRentDateStart = Date.parse(this.filterQuery.leaseTerm[0]).valueOf()+28800000,
                    filterRentDateEnd = Date.parse(this.filterQuery.leaseTerm[1]).valueOf()+28800000
                    // console.log(houseItem)
                    // console.log(rentDateEnd)
                    // console.log(filterRentDateEnd)
                if( filterRentDateStart && filterRentDateEnd ){
                    if( rentDateStart && rentDateEnd ){
                        if( filterRentDateStart <= rentDateStart && rentDateEnd <= filterRentDateEnd ){
                            return houseItem
                        }
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByRent: function () {
            return this.filterByContract.filter((houseItem) => {
                if( this.filterQuery.rent ){
                    if( this.filterQuery.rent[1] >= 100000){
                        if( this.filterQuery.rent[0] <= houseItem.rentPrice){
                            return houseItem
                        }
                    }else{
                        if( this.filterQuery.rent[0] <= houseItem.rentPrice && this.filterQuery.rent[1] >= houseItem.rentPrice ){
                            return houseItem
                        }
                    }
                    
                }else{
                    return houseItem
                }
            });
        },
        ...mapGetters({
            filterQuery: 'FILTER_QUERY',
            filterResult: 'FILTER_RESULT',
            districtHouseUid: 'DISTRICT_HOUSE_UID',
        })
    },
    methods: {
        showCover: function () {
            let cover = event.target.children[2];
            cover.style.display = 'block';
        },
        hideCover: function () {
            let cover = event.target.children[2];
            cover.style.display = 'none';
        },
        coverInfo: function (edate, ldate) {
            if(edate && edate <= 30){
                return '空 '+edate+' 天'
            }else if(edate){
                return '已空房超過 30 天'
            }
            if(ldate && ldate <= 30){
                return '剩 '+ldate+' 天'
            }else if(ldate){
                return '離合約到期超過30天'
            }
        },
        translateStateColor: function (state) {
            if( state == '1' ){
                return 'blue';
            }else if( state == '9' ){
                return 'green';
            }else if( state == '2' ){
                return 'red';
            }else if( state == '3' ){
                return 'black';
            }else if( state == '4' ){
                return 'yellow';
            }
        },
        translateStateImg: function (state, active) {
            if( active ){
                if( state == '1' ){
                    return require('../../../assets/img/icon/landlord_check_green.svg');
                }else if( state == '9' ){
                    return require('../../../assets/img/icon/tanant_check_green.svg');
                }else if( state == '2' ){
                    return require('../../../assets/img/icon/arrears_green.svg');
                }else if( state == '3' ){
                    return require('../../../assets/img/icon/recently_green.svg');
                }else if( state == '4' ){
                    return require('../../../assets/img/icon/collect_green.svg');
                }
            }else{
                if( state == '1' ){
                    return require('../../../assets/img/icon/landlord_check_white.svg');
                }else if( state == '9' ){
                    return require('../../../assets/img/icon/tanant_check_white.svg');
                }else if( state == '2' ){
                    return require('../../../assets/img/icon/arrears_white.svg');
                }else if( state == '3' ){
                    return require('../../../assets/img/icon/recently_white.svg');
                }else if( state == '4' ){
                    return require('../../../assets/img/icon/collect_white.svg');
                }
            }
            
        },
        toggleClose: function () {
            this.isClose = !this.isClose
        },
        getHouseInfo: function (index) {
            this.filterByRent[index].county = this.county
            this.filterByRent[index].district = this.district
            // console.log(this.house[index])
            this.$emit('getHouseInfo', this.filterByRent[index])
        },
        setDistrictHouseUid: function () {
            this.$store.dispatch('setDistrictHouseUid', this._uid)
        },
        filterStatus: function (arr) {
            let allowStatus = this.$store.getters.DEFAULT_FILTER_STATUS

            let status =  arr.map( item => {
                if( item != 0 && item != 5 && allowStatus.includes(item)){
                    return item
                }
            })

            return this.getArrEqual(this.filterQuery.status, status)
        },
        getArrEqual(arr1, arr2) {
            let newArr = [];
            for (let i = 0; i < arr2.length; i++) {
                for (let j = 0; j < arr1.length; j++) {
                    if(arr1[j] == arr2[i]){
                        newArr.push(arr1[j]);
                    }
                }
            }
            return newArr;
        },
    }
}
</script>
<style scoped lang="scss">
    .district-house{
        position: relative;
        background: #fff;
        border: solid 1px #e0dfde;
        width: 811px;
        padding: 24px;
        margin-bottom: 25px;
        border-radius: 8px;
        .title{
            display: block;
            font-size: 16px;
            color: #a8a5a4;
            margin-bottom: 24px;
            .total{
                display: none;
                font-size: 16px;
                color: #ff9275;
                margin-left: 8px;
            }
        }
        .toggle-close{
            position: absolute;
            right: 20px;
            top: 20px;
            cursor: pointer;
        }
        > ul{
            display: flex;
            flex-wrap: wrap;
            > li.rented{
                border: 1px solid #676362;
            }
            > li.active{
                border: 1px solid #ff9275;
                background: #ff9275;
                color: #fff;
                .state > ul > li span{
                    background: #fff !important;
                }
            }
            > li:nth-child(4n){
                margin-right: 0px;
            }
            > li{
                position: relative;
                width: 158px;
                // height: 56px;
                border: 1px solid #d5dad8;
                border-radius: 8px;
                margin-right: 17px;
                margin-bottom: 17px;
                padding: 15px;
                .address{
                    line-height: 1.5;
                }
                .floor{
                    line-height: 1.5;
                    font-weight: 300;
                }
                cursor: pointer;
                .cover{
                    position: absolute;
                    display: none;
                    width: 100%;
                    height: 100%;
                    z-index: 3;
                    left: 0;
                    top: 0;
                    span{
                        position: absolute;
                        color: #fff;
                        width: 100%;
                        height: 100%;
                    }
                    span.active-cover{
                        background: #676362;;
                        border-radius: 5px;
                        opacity: 0.8;
                    }
                    span.active-word{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        z-index: 2;
                    }
                }
                .state{
                    display: block;
                    position: relative;
                    margin-bottom: 8px;
                    height: 22px;
                    > ul{
                        display: flex;
                        > li{
                            margin-right: 8px;
                            span{
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                width: 24px;
                                height: 22px;
                                border-radius: 7.5px;
                            }
                            span.blue{
                                background: #71aae5;
                            }
                            span.black{
                                background: #676362;
                            }
                            span.red{
                                background: #fc7171;
                            }
                            span.yellow{
                                background: #fcb773;
                            }
                            span.green{
                                background: #3942b5;
                            }
                        }
                    }
                }
            }
        }
    }
    .district-house.loading{
        .title{
            animation-name: loading;
            animation-duration: 3s;
            animation-iteration-count: infinite;
            width: 302px;
            height: 20px;
            border-radius: 5px;
            background-color: #f0f0f0;
        }
        > ul{
            
            > li{
                width: 158px;
                height: 76px;
                .address{
                    animation-name: loading;
                    animation-duration: 3s;
                    animation-iteration-count: infinite;
                    display: block;
                    width: 158px;
                    height: 16px;
                    border-radius: 4px;
                    background-color: #f0f0f0;
                }
                .state{
                    animation-name: loading;
                    animation-duration: 3s;
                    animation-iteration-count: infinite;
                    > ul{
                        > li{
                            span{
                                background-color: #f0f0f0;
                            }
                        }
                    }
                }
            }
        }
    }
    .district-house.no-house{
        height: 152px;
        .title{
            font-size: 14px;
            margin-bottom: 36px;
        }
        .wrap{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            button{
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 24px;
                width: 122px;
                height: 44px;
            }
        }
    }
    .district-house.close{
        height: 24px;
        .title{
            .total{
                display: inline;
            }
        }
        > ul{
            display: none;
        }
    }
    .filter-no-house:not(:nth-child(2)){
        display: none;
    }
    .filter-no-house{
        .no-result{
            padding: 31px 0 56px 0;
            text-align: center;
        }
    }
    
    @keyframes loading {
        0%   {opacity: 1;}
        50%   {opacity: 0.3;}
        100% {opacity: 1;}
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/DistrictHouse.vue